var Cart = function() {

  	this.cart = {};
  	this.onHoldProducts = [];
  
    this.setCart = function(callback){      
      scope = this;
      scope.onHoldProducts = [];
      $('#add-cart-overlay').show();
      
      $.ajax({
        type: 'GET',
        url: '/cart?view=json',
        success: function(response){
          	try {
            	scope.cart = JSON.parse(response);
            } catch(ex){}

          	if(callback) {
          		callback();
            }
        },
        error: function(e){
          if(callback) {
          	callback();
          }
        }
      });
    }
    
    this.bindEvents = function(){
      scope = this;
      $('.checkout-button input, #additional-checkout-buttons input, #additional-checkout-buttons button').click(function(e, validated){
        e.stopPropagation();

        try {
          if(!validated) {
              e.preventDefault();
              scope.setCart(function(){
                  // Last theme-side chance to fix the additional product before the
                  // customer leaves for checkout. If it changed the cart, reload so
                  // the rendered table matches what is actually in it.
                  reconcileAdditionalProduct(scope.cart, function(changed){
                      if(changed) {
                          window.location.reload();
                          return;
                      }
                      scope.initVariantStatus();
                      if(scope.onHoldProducts.length > 0){
                          $('#add-cart-overlay').hide();
                          scope.showOnHold($(e.target));
                      } else {
                          $(e.target).trigger('click', true);
                      }
                  }, { skipRefresh: true });
              });
              return false;
          }
        } catch(ex){}
      });
    }
    
    this.showOnHold = function(buttonTarget){
      	scope = this;
      	var onholdTime = false; 
      	if(settings.automatically_onhold_date!="") {
      		onholdTime = $.trim(settings.automatically_onhold_date).split(" ")[1];
      	}
      	
      	content = '<div id="onhold-products">';
      	content += '<h3>Some products in your cart <br/> are on hold'+(onholdTime ? ' until '+onholdTime+' EST' : '')+'.</h3>';
      	content += '<ul>'
        for(productKey in scope.onHoldProducts){
          	product = scope.onHoldProducts[productKey];
          	productImageSrc = product.item.image.split('?')[0];
          	fileExt = productImageSrc.split('.').pop();
          	var smallImg = productImageSrc.slice(0, ((fileExt.length*-1)-1))+'_small.'+fileExt;
          	
			content += '<li class="onhold-product">';
          		content += '<div class="image"><img src="'+smallImg+'" title="'+product.item.title+'" alt="'+product.item.title+'" /></div>';
          		content += '<div class="title">'+product.item.title+'</div>';
          	content += '</li>';
        }
      	content += '</ul>';
      	content += '<div class="action-btns">';
      		content += '<input id="continueShopping" type="button" class="animation" value="Continue Shopping" />';
      		content += '<input id="removeAndCheckout" type="button" class="animation" value="Remove items and checkout"/>';
      	content += '</div>';
      	content += '</div>';
      
      	Simplistic.openModal(content);
      	scope.bindOnHoldEvents(buttonTarget);
    }
    
    this.bindOnHoldEvents = function(buttonTarget){
      	var scope = this;

        var removeItem = function(cartItem){
            var select = cartItem.find('select[name="updates[]"]');
            select.append('<option value="0">0</option>');
            select.find('option[value=0]').attr("selected", "selected");
            cartItem.find('input[name="updates[]"]').val(0);
        };

    	$('#removeAndCheckout').click(function(e){
            e.preventDefault();
            for(productKey in scope.onHoldProducts){
              var item = scope.onHoldProducts[productKey];
              var cartItem = $('#cartform .items [data-item-key="'+item.item.key+'"]');

              if(cartItem.data('bundle-parent')) {
                var bundleCode = cartItem.data('bundle-parent');
                $('[data-bundle="'+bundleCode+'"]').each(function(){
                    removeItem($(this));
                });
              }
              removeItem(cartItem);
            }
          	buttonTarget.trigger('click', true);
          });

        $('#continueShopping').click(function(){
          window.location = "/"
        });
    }
  
	this.init = function() {
      	this.bindEvents();
      	return this;
	};

	this.initVariantStatus = function() {
      	var scope = this;
      	var items = scope.cart.items;
      	var msg = '';
		$.each(items, function(key, item){
            var props = item.item.properties;
            var isThemeManaged = props != null && (props.hasOwnProperty('_bundle') || props.hasOwnProperty('_gwp'));
            if(!isThemeManaged) {
    			if(isOnHold(item)) {
                  scope.onHoldProducts.push(item);
    			}
            }
		})
	};
  
  	this.isOnHoldCategories = function(item){
      	var result = null;

      	for(var i=1; i<=5; i++) {
          	var productsOnHold = settings['on_hold_products_'+i].replace(/\r/g, '').split('\n');
          	var variantsOnHold = settings['on_hold_variants_'+i].replace(/\r/g, '').split('\n');
          	var stockOnHold = settings['on_hold_stock_'+i];

            if((productsOnHold!="" && $.inArray(item.item.handle, productsOnHold)>-1) ||
            (variantsOnHold!="" && $.inArray(item.variant[settings['on_hold_variants_by_'+i]], variantsOnHold)>-1)) {
                if(stockOnHold=="" || item.variant.inventory_quantity<=stockOnHold) {
                    result = true;
                } else {
                    result = false;
                }
              	break;
            }
      	}
      
      	return result;
  	};
  
  	this.isOnHold = function(item) {
      	if(settings.automatically_onhold && item.product.handle.indexOf("backorder") < 0) {
          	var time = currentTime.replace(/-/g, "").replace(/ /g, "").replace(/:/g, "");
          	var onholdDate = settings.automatically_onhold_date.replace(/-/g, "").replace(/ /g, "").replace(/:/g, "");

          	if(onholdDate=="" || time<onholdDate) {
              	var categoriesOnHold = isOnHoldCategories(item);
              	if(categoriesOnHold!=null) {
                	return categoriesOnHold;
                } else {
                  	if(settings.automatically_onhold_stock!="" && item.variant.inventory_quantity<=settings.automatically_onhold_stock) {
                  		return true;
                  	}
                }
          	}
      	}
      	return false;
  	};
  
	return init();
  
};